import { render, staticRenderFns } from "./RestaurantCategories.vue?vue&type=template&id=273a6625"
import script from "./RestaurantCategories.vue?vue&type=script&lang=js"
export * from "./RestaurantCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports